import { SimpleGLOverlay } from "./SimpleGLOverlay";
import { buildPathsMesh } from "./PathRender";
export class PathOverlay3d extends SimpleGLOverlay {
    constructor(paths, mesh) {
        super(mesh);
        this.paths = paths;
    }
    static async forPaths(paths) {
        return new PathOverlay3d(paths, (await buildPathsMesh(paths)).finalize());
    }
}
